import db from "./db";
import { supabase } from "../supabase"; // adjust path if needed

export async function saveOffline(selectedService, selectedBand, setError, setNotification) {
  if (!selectedService || !selectedBand) {
    setError("Select a service first.");
    return;
  }

  try {
    // 1️⃣ Fetch service details
    const { data: serviceData, error: sErr } = await supabase.from("services").select("*").eq("id", selectedService).single();
    if (sErr) throw sErr;

    // 2️⃣ Fetch service songs
    const { data: serviceSongs, error: ssErr } = await supabase.from("servicessongs").select("*, songs(*)").eq("serviceid", selectedService).order("order", { ascending: true });
    if (ssErr) throw ssErr;

    // 3️⃣ Clear & store
    await db.offlineService.clear();
    await db.offlineSongs.clear();

    await db.offlineService.put(serviceData);
    for (const ss of serviceSongs) {
      await db.offlineSongs.put({
        songid: ss.songid,
        ...ss.songs,
        custom_key: ss.custom_key,
        order: ss.order,
      });
    }
    await db.meta.put({ key: "lastSaved", value: new Date().toISOString() });

    setNotification("Service saved for offline use!");
  } catch (err) {
    console.error(err);
    setError("Failed to save offline: " + err.message);
  }
}

export async function loadOffline() {
  const service = await db.offlineService.toArray();
  const songs = await db.offlineSongs.toArray();
  return { service, songs };
}
